import { useQuery } from '@tanstack/react-query'
import api from '../../api'
import type { MultiTenantRequest } from '../../types/multiTenantRequest'

const useMultiTenantRequests = (clusterId: string) => {
	return useQuery({
		queryKey: ['multiTenantRequests', clusterId],
		queryFn: () => api.multiTenantRequests.getMultiTenantRequests(clusterId),
		enabled: !!clusterId,
		retry: false,
		select(data) {
			return (data?.body ?? []) as Array<MultiTenantRequest>
		}
	})
}

export default useMultiTenantRequests
